import { useState } from "react";
import Forms from "components/shared/Forms";
import { FormFieldType, ICustomFormField } from "models/properties";
import { hasReadOnlyAccess } from "components/AppContent";
import { IPolicyInfo } from "../types";

function PolicyEditProperties({ policyInfo }: { policyInfo: IPolicyInfo }) {
  const isReadOnly = hasReadOnlyAccess();
  const [formData, setFormData] = useState({
    name: policyInfo.name,
    description: policyInfo.description,
  });
  const policyTypeOptions = [
    { key: "Implicit Acceptance", text: "Implicit Acceptance" },
  ];
  const formFields: ICustomFormField[] = [
    {
      type: FormFieldType.select,
      propertyName: "type",
      propertyType: "properties",
      label: "Policy Type",
      required: false,
      value: policyInfo.type,
      defaultValue: policyInfo.type,
      disabled: true,
      placeholder: "",
      dataAutomationId: "policyTypeField",
      width: "420px",
      options: policyTypeOptions,
    },
    {
      type: FormFieldType.textField,
      propertyName: "name",
      propertyType: "properties",
      label: "Policy name",
      required: true,
      value: formData.name,
      defaultValue: policyInfo.name,
      disabled: isReadOnly,
      placeholder: "",
      dataAutomationId: "policyNameField",
      width: "420px",
    },
    {
      type: FormFieldType.textField,
      propertyName: "description",
      propertyType: "properties",
      label: "Description",
      required: false,
      value: formData.description,
      defaultValue: policyInfo.description,
      disabled: isReadOnly,
      placeholder: "",
      dataAutomationId: "policyDescriptionField",
      width: "420px",
    },
  ];

  const onPropertyChanged = (
    propertyType: string,
    propertyName: string,
    newValue: string | undefined,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _defaultValue: string | undefined
  ) => {
    setFormData(prev => ({
      ...prev,
      [propertyName]: newValue || ""
    }));
  };

  const onPropertyBlur = (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _propertyType: string,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _propertyName: string,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _newValue: string | undefined
  ) => {
    // Handle blur events if needed
  };

  const formWrapperStyle = {
    width: "65%",
    maxWidth: "1200px",
    backgroundColor: "white",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    borderRadius: "4px",
    padding: 24,
    minHeight: "calc(100vh - 180px)",
  };

  return (
    <div style={formWrapperStyle}>
      <Forms
        formFields={formFields}
        onPropertyChanged={onPropertyChanged}
        onPropertyBlur={onPropertyBlur}
      />
    </div>
  );
}

export default PolicyEditProperties;